(() => {
  const addMissingSpacesAfterBold = (root = document) => {
    root.querySelectorAll('.rte strong, .rte b, .accordion-rich-content strong, .accordion-rich-content b').forEach((bold) => {
      const next = bold.nextSibling;
      if (!next || next.nodeType !== Node.TEXT_NODE || !next.textContent) return;
      if (/^\s/.test(next.textContent)) return;
      if (/^[,.;:!?…%)\]}]/.test(next.textContent)) return;
      next.textContent = ` ${next.textContent}`;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => addMissingSpacesAfterBold(), { once: true });
  } else {
    addMissingSpacesAfterBold();
  }

  document.addEventListener('shopify:section:load', (event) => addMissingSpacesAfterBold(event.target));
})();
